import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconTeacherWhiteboard: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="square-filled-radius-0-stroke-1.5-IconTeacherWhiteboard"><Path d="M11.25 3H9.75V4H1V5.5H2V16.5H1V18H10V16.5H3.5V5.5H17.5V7H19V5.5H20V4H11.25V3Z" fill="currentColor"/><Path d="M17 9C15.3431 9 14 10.3431 14 12C14 13.6569 15.3431 15 17 15C18.6569 15 20 13.6569 20 12C20 10.3431 18.6569 9 17 9Z" fill="currentColor"/><Path d="M17 15.5C14.1947 15.5 12.2441 17.5973 12.0032 20.1804L11.9268 21H22.0732L21.9968 20.1804C21.7559 17.5973 19.8053 15.5 17 15.5Z" fill="currentColor"/></CentralIconBase>;
});

export default IconTeacherWhiteboard;
